/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { JudgingState } from './JudgingState';
import {
    JudgingStateFromJSON,
    JudgingStateFromJSONTyped,
    JudgingStateToJSON,
    JudgingStateToJSONTyped,
} from './JudgingState';

/**
 * One participant's practice submissions on one workshop problem, aggregated in SQL.
 * 
 * Only pairs with at least one submission are listed. `best_points` is null while no submission
 * has points (still being judged, or a problem type that is never scored), so a submitted but
 * unscored cell stays distinguishable from one never attempted. `judging` is the state of the
 * newest submission while it has no points (an evaluatable problem only): `failed` once it is
 * older than the judging threshold, else `pending`; null once it is judged (#247). A cell with
 * points whose newest submission failed keeps its `best_points` and carries `failed`.
 * @export
 * @interface WorkshopProblemScore
 */
export interface WorkshopProblemScore {
    /**
     * 
     * @type {string}
     * @memberof WorkshopProblemScore
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopProblemScore
     */
    problem_id: string;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemScore
     */
    best_points?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopProblemScore
     */
    attempts: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopProblemScore
     */
    last_submitted_at?: Date | null;
    /**
     * 
     * @type {JudgingState}
     * @memberof WorkshopProblemScore
     */
    judging?: JudgingState | null;
}



/**
 * Check if a given object implements the WorkshopProblemScore interface.
 */
export function instanceOfWorkshopProblemScore(value: object): value is WorkshopProblemScore {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    return true;
}

export function WorkshopProblemScoreFromJSON(json: any): WorkshopProblemScore {
    return WorkshopProblemScoreFromJSONTyped(json, false);
}

export function WorkshopProblemScoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopProblemScore {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
        'problem_id': json['problem_id'],
        'best_points': json['best_points'] == null ? undefined : json['best_points'],
        'attempts': json['attempts'],
        'last_submitted_at': json['last_submitted_at'] == null ? undefined : (new Date(json['last_submitted_at'])),
        'judging': json['judging'] == null ? undefined : JudgingStateFromJSON(json['judging']),
    };
}

export function WorkshopProblemScoreToJSON(json: any): WorkshopProblemScore {
    return WorkshopProblemScoreToJSONTyped(json, false);
}

export function WorkshopProblemScoreToJSONTyped(value?: WorkshopProblemScore | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
        'problem_id': value['problem_id'],
        'best_points': value['best_points'],
        'attempts': value['attempts'],
        'last_submitted_at': value['last_submitted_at'] == null ? undefined : ((value['last_submitted_at'] as any).toISOString()),
        'judging': JudgingStateToJSON(value['judging']),
    };
}

